import * as React from 'react';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { connect } from 'react-redux';
import { SVG, SVGEnum } from 'HelperFunctions/SVG';
type DispatchedProps = {
    summaryMapManage: (type: ViewManagementModule.Types.SummaryMapManageType) => Function;
};
type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

export const SummaryMapManagement = (props: DispatchedProps & ConnectedProps) => {
    const { summaryMapManage, viewManagementStore } = props;
    return (
        <div className="map-manage__wrapper">
            <button onClick={() => summaryMapManage('car')} className={`map-manage__btn ${viewManagementStore.summaryMapView.car ? 'map-manage__btn--active' : ''}`}>
                <SVG type={SVGEnum.TYPE_CAR} />
            </button>
            <button onClick={() => summaryMapManage('aoi')} className={`map-manage__btn ${viewManagementStore.summaryMapView.aoi ? 'map-manage__btn--active' : ''}`}>
                <SVG type={SVGEnum.TYPE_AOI} />
            </button>
            <button onClick={() => summaryMapManage('poi')} className={`map-manage__btn ${viewManagementStore.summaryMapView.poi ? 'map-manage__btn--active' : ''}`}>
                <SVG type={SVGEnum.TYPE_POI} />
            </button>
        </div>
    );
};
function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        summaryMapManage: (type: ViewManagementModule.Types.SummaryMapManageType) => dispatch(ViewManagementModule.Actions.summaryMapManage(type))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(SummaryMapManagement);



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/SummaryMapManagement.tsx